"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  BrokenTabRemove: ['broken-tab-remove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.719,16.33a.477.477,0,0,1-.05.455.5.5,0,0,1-.414.215H1.751a.988.988,0,0,1-1-.975v-7.8a.988.988,0,0,1,1-.975H12.256a.507.507,0,0,1,.415.213.477.477,0,0,1,.05.455l-1.654,4.041a.476.476,0,0,0,0,.363Z', 'M16.5,17a.488.488,0,0,1-.452-.306l-1.755-4.372a.49.49,0,0,1,0-.363l1.755-4.4A.487.487,0,0,1,16.5,7.25h5.775a.975.975,0,0,1,.975.975v7.8a.976.976,0,0,1-.975.975Z', 'M18 10.657L20.935 13.592', 'M20.935 10.657L18 13.592']],
  AddBold: ['add-bold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,8.25h-4.5V3.75a3,3,0,0,0-3-3h-1.5a3,3,0,0,0-3,3v4.5H3.75a3,3,0,0,0-3,3v1.5a3,3,0,0,0,3,3h4.5v4.5a3,3,0,0,0,3,3h1.5a3,3,0,0,0,3-3v-4.5h4.5a3,3,0,0,0,3-3v-1.5A3,3,0,0,0,20.25,8.25Z']],
  AddCircle1: ['add-circle-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,3.816A9,9,0,0,0,6,20.182', 'M5.250 12.000 A9.000 9.000 0 1 0 23.250 12.000 A9.000 9.000 0 1 0 5.250 12.000 Z', 'M14.25 7.5L14.25 16.5', 'M9.75 12L18.75 12']],
  AddTab: ['add-tab', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.938,18H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25,6H18.938a1.5,1.5,0,0,1,1.272.705l2.812,4.5a1.5,1.5,0,0,1,0,1.59L20.21,17.3A1.5,1.5,0,0,1,18.938,18Z', 'M6.75 9.75L6.75 14.25', 'M4.5 12L9 12']],
  AddCircleBold: ['add-circle-bold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M17.25,9.75h-3v-3a1.5,1.5,0,0,0-1.5-1.5h-1.5a1.5,1.5,0,0,0-1.5,1.5v3h-3a1.5,1.5,0,0,0-1.5,1.5v1.5a1.5,1.5,0,0,0,1.5,1.5h3v3a1.5,1.5,0,0,0,1.5,1.5h1.5a1.5,1.5,0,0,0,1.5-1.5v-3h3a1.5,1.5,0,0,0,1.5-1.5v-1.5A1.5,1.5,0,0,0,17.25,9.75Z']],
  AddCircle: ['add-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 7.5L12 16.5', 'M7.5 12L16.5 12', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  RemoveBold: ['remove-bold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.823,1.805,12,5.628,8.177,1.805a3.605,3.605,0,0,0-5.1,0L1.806,3.079a3.6,3.6,0,0,0,0,5.1L5.629,12,1.806,15.822a3.6,3.6,0,0,0,0,5.1L3.08,22.194a3.605,3.605,0,0,0,5.1,0L12,18.371l3.823,3.823a3.605,3.605,0,0,0,5.1,0l1.274-1.274a3.6,3.6,0,0,0,0-5.1L18.372,12l3.822-3.824a3.6,3.6,0,0,0,0-5.1L20.92,1.805A3.605,3.605,0,0,0,15.823,1.805Z']],
  RemoveCircle: ['remove-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.182 8.818L8.818 15.181', 'M8.818 8.818L15.182 15.181', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  SubtractTab: ['subtract-tab', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.938,18H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25,6H18.938a1.5,1.5,0,0,1,1.272.705l2.812,4.5a1.5,1.5,0,0,1,0,1.59L20.21,17.3A1.5,1.5,0,0,1,18.938,18Z', 'M4.5 12L9 12']],
  SubtractCircleBold: ['subtract-circle-bold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.250 9.750 L18.750 9.750 L18.750 14.250 L5.250 14.250 Z']],
  RemoveTab: ['remove-tab', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.938,18H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25,6H18.938a1.5,1.5,0,0,1,1.272.705l2.812,4.5a1.5,1.5,0,0,1,0,1.59L20.21,17.3A1.5,1.5,0,0,1,18.938,18Z', 'M5.159 10.408L8.341 13.591', 'M5.159 13.591L8.341 10.408']],
  SubtractBold: ['subtract-bold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 8.250 L23.250 8.250 L23.250 15.750 L0.750 15.750 Z']],
  SubtractCircle: ['subtract-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 12L16.5 12', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  RemoveCircleBold: ['remove-circle-bold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M17.3,14.121,15.182,12,17.3,9.878a1.5,1.5,0,0,0,0-2.121L16.243,6.7a1.5,1.5,0,0,0-2.122,0L12,8.818,9.879,6.7a1.5,1.5,0,0,0-2.122,0L6.7,7.757a1.5,1.5,0,0,0,0,2.121L8.818,12,6.7,14.121a1.5,1.5,0,0,0,0,2.121L7.757,17.3a1.5,1.5,0,0,0,2.122,0L12,15.182,14.121,17.3a1.5,1.5,0,0,0,2.122,0l1.06-1.061A1.5,1.5,0,0,0,17.3,14.121Z']],
  Subtract: ['subtract', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 12.038L23.25 12.038']],
  Add: ['add', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 12L23.25 12', 'M12 0.75L12 23.25']],
  AddSquare: ['add-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 7.5L12 16.5', 'M7.5 12L16.5 12', 'M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z']],
  RemoveSquare1: ['remove-square_1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.182 8.818L8.818 15.181', 'M8.818 8.818L15.182 15.181', 'M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z']],
  Remove: ['remove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5 19.5L19.5 4.5', 'M4.5 4.5L19.5 19.5']],
  SubtractSquare: ['subtract-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 12L16.5 12', 'M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z']]
};
exports["default"] = _default;